import { AuthProvider } from '../providers/auth.provider';

export const RolesNotAllowGuard = function(to, from, next) {
  const rolesNotAllow = this.rolesNotAllow;
  const path = this.path;
  const name = this.name;

  if (!AuthProvider.isUserAllowed(rolesNotAllow)) {
    if (path) {
      next({ path });

      return
    }

    if (name) {
      next({ name });

      return
    }

    next({ path: '/403' });
  }

  next();
}